// Scroll Down (Home_Top --> what_we_do)
$(document).on("click",".home_top .btn_scroll",function(){
    var posicion=$(".about_us").offset().top;
    $("html,body").animate({scrollTop:posicion-60},1000);
});
